import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getWorkshops,
} from "../../redux/slice/workshopSlice";
import {
  Typography, Grid, TextField, Button, IconButton, Select, MenuItem,
  FormControl, InputLabel, Card, CardMedia, CardContent, InputAdornment
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EventIcon from '@mui/icons-material/Event';
import GridViewIcon from '@mui/icons-material/GridView';
import { toast } from "react-toastify";
import ViewListIcon from '@mui/icons-material/ViewList';

const AllWorkshops = ({ limit = 10 }) => {
  const dispatch = useDispatch();
  const { workshops, totalPage } = useSelector((state) => state.workshop);

  const [page, setPage] = useState(1);
  const [sort, setSort] = useState("");
  const [search, setSearch] = useState("");
  const [locationSearch, setLocationSearch] = useState("");
  const [isListMode, setIsListMode] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [showEnrollForm, setShowEnrollForm] = useState(false);
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: ''
  });

  const handleEnrollClick = (workshop) => {
  setSelectedWorkshop(workshop);
  setShowModal(true);
};

const handleCloseModal = () => {
  setShowModal(false);
  setShowEnrollForm(false);
  setSelectedWorkshop(null);
  setFormData({ name: '', email: '', phone: '', address: '' });
};

const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({ ...prev, [name]: value }));
};

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!selectedWorkshop?._id) {
    toast.error("Workshop ID not found");
    return;
  }

  try {
    const response = await fetch( process.env.REACT_APP_API_URL + `/workshopEnrollment/${selectedWorkshop._id}/enroll`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (data.status === "success") {
     toast.success("You have enrolled successfully")
      handleCloseModal();
    } else {
      toast.error("Failed to submit")
    }
  } catch (error) {
    console.error("Enrollment error:", error);
    toast.error(error);
  }
};



  useEffect(() => {
    dispatch(getWorkshops({ page, sort, search, location: locationSearch, limit }));
  }, [page, sort, search, locationSearch, limit]);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    dispatch(getWorkshops({ page: 1, sort, search, location: locationSearch, limit }));
  };

  const handleSortChange = (e) => {
    const value = e.target.value;
    setSort(value);
    setPage(1);
    dispatch(getWorkshops({ page: 1, sort: value, search, location: locationSearch, limit }));
  };

  const sortedWorkshops = () => {
    if (!workshops) return [];

    let filtered = [...workshops];

    if (locationSearch) {
      filtered = filtered.filter(workshop =>
        workshop.locationName?.toLowerCase().includes(locationSearch.toLowerCase())
      );
    }

    switch (sort) {
      case "priceAsc":
        filtered.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
        break;
      case "priceDesc":
        filtered.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
        break;
      case "newest":
        filtered.sort((a, b) => new Date(b.workshopStartDate) - new Date(a.workshopStartDate));
        break;
      default:
        break;
    }

    return filtered.slice(0, limit);
  };

  return (
    <>
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 2, color: '#2596be' }}>
        Deeptech <span style={{ color: '#000' }}>Workshops</span>
      </Typography>

      {/* Search & Filter Section */}
      <Grid container spacing={2} sx={{ mb: 3 }} alignItems="center">
        <Grid item xs={12} sm={4}>
          <form onSubmit={handleSearch}>
            <TextField
              fullWidth
              placeholder="Search Workshops"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton type="submit">
                      <SearchIcon sx={{ color: "#2596be" }} />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              size="small"
            />
          </form>
        </Grid>

        <Grid item xs={12} sm={3}>
          <form onSubmit={handleSearch}>
            <TextField
              fullWidth
              placeholder="Search by Location"
              value={locationSearch}
              onChange={(e) => setLocationSearch(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton type="submit">
                      <SearchIcon sx={{ color: "#2596be" }} />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              size="small"
            />
          </form>
        </Grid>

        <Grid item xs={6} sm={2}>
          <IconButton onClick={() => setIsListMode(true)}><ViewListIcon sx={{ color: isListMode ? "#2596be" : "#888" }} /></IconButton>
          <IconButton onClick={() => setIsListMode(false)}><GridViewIcon sx={{ color: !isListMode ? "#2596be" : "#888" }} /></IconButton>
        </Grid>

        <Grid item xs={6} sm={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Sort By</InputLabel>
            <Select value={sort} label="Sort By" onChange={handleSortChange}>
              <MenuItem value="priceAsc">Price -- Low to High</MenuItem>
              <MenuItem value="priceDesc">Price -- High to Low</MenuItem>
              <MenuItem value="newest">Newest First</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      {/* Workshop Cards */}
      <Grid container spacing={3}>
  {sortedWorkshops().map((obj, index) => (
    <Grid
      item
      xs={12}
      sm={isListMode ? 12 : 6}
      md={isListMode ? 12 : 4}
      key={index}
    >
      <Card
        sx={{
          height: "100%",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CardMedia
          component="img"
          height="200"
          image={obj.workshopImage || "/images/default.jpg"}
          alt={obj.workshopName}
        />

        <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {obj.workshopName}
          </Typography>

          <div className="d-flex align-items-center" style={{ gap: 8 }}>
            <LocationOnIcon fontSize="small" />
            <Typography variant="body2" color="textSecondary">
              {obj.workshopLocationName}
            </Typography>
          </div>

          <div className="d-flex align-items-center" style={{ gap: 8 }}>
            <EventIcon fontSize="small" />
            <Typography variant="body2" color="textSecondary">
              {obj.workshopStartDate}
            </Typography>
          </div>

          {/* 👇 Bottom Section */}
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ marginTop: "auto" }}
          >
            <Typography
              variant="h6"
              sx={{ color: "#2596be", fontWeight: 600 }}
            >
              ₹{new Intl.NumberFormat("en-IN").format(obj.workshopPrice)}
            </Typography>

            <Button
              variant="outlined"
              size="small"
              onClick={() => handleEnrollClick(obj)}
            >
              Enroll Now
            </Button>
          </div>
        </CardContent>
      </Card>
    </Grid>
  ))}
</Grid>


      {/* Load More */}
      {page < totalPage && (
        <Grid container justifyContent="center" sx={{ mt: 4 }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#2596be", px: 4 }}
            onClick={() => setPage(page + 1)}
          >
            Load More
          </Button>
        </Grid>
      )}

      {selectedWorkshop && showModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 z-[1050] flex justify-center items-start md:items-center p-4 overflow-y-auto">
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[1100px] p-4 md:p-6 lg:p-8 mt-16 md:mt-32 mb-8">
      {/* Header */}
      <div className="flex justify-between items-center mb-4 md:mb-6">
        <h2 className="text-xl md:text-2xl font-bold text-gray-800">
          {selectedWorkshop.workshopName}
        </h2>
        <button 
          onClick={handleCloseModal}
          className="text-gray-500 hover:text-gray-700 text-2xl bg-transparent border-none focus:outline-none"
          aria-label="Close modal"
        >
          &times;
        </button>
      </div>

      {/* Body */}
      <div className="flex flex-col lg:flex-row gap-4 md:gap-6">
        {/* Left Section */}
        <div className="lg:w-2/3">
          <img
            src={selectedWorkshop.workshopImage}
            alt="Workshop"
            className="w-full h-48 sm:h-64 md:h-80 lg:h-96 object-cover rounded-xl mb-3 md:mb-4"
          />
          {selectedWorkshop.workshopDescription && (
            <>
              <h4 className="text-base md:text-lg font-semibold mb-1 md:mb-2">About This Workshop</h4>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                {selectedWorkshop.workshopDescription}
              </p>
            </>
          )}
        </div>

        {/* Right Section */}
        <div className="lg:w-1/3 space-y-4 md:space-y-6">
          <div className="bg-gray-100 p-3 md:p-4 rounded-xl">
            <h4 className="font-semibold text-sm md:text-base mb-2 md:mb-3">Workshop Details</h4>
            <ul className="text-xs md:text-sm text-gray-700 space-y-1 md:space-y-2">
              <li><strong>Location:</strong> {selectedWorkshop.workshopLocationName}</li>
              <li><strong>Date:</strong> {selectedWorkshop.workshopStartDate}</li>
              <li><strong>Duration:</strong> {selectedWorkshop.workshopDuration} Days</li>
              <li><strong>Type:</strong> {selectedWorkshop.workshopType}</li>
              <li><strong>Price:</strong> ₹{new Intl.NumberFormat("en-IN").format(selectedWorkshop.workshopPrice)}</li>
            </ul>
          </div>

          {selectedWorkshop?.workshopRequirements && (
            <div className="bg-gray-100 p-3 md:p-4 rounded-xl">
              <h4 className="font-semibold text-sm md:text-base mb-2 md:mb-3">
                Requirements
              </h4>
              <div
                className="text-xs md:text-sm text-gray-700 space-y-1"
                dangerouslySetInnerHTML={{ __html: selectedWorkshop.workshopRequirements }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="flex flex-col-reverse sm:flex-row justify-end gap-2 md:gap-4 mt-6 md:mt-8">
        <button
          onClick={handleCloseModal}
          className="px-4 py-1.5 sm:px-6 sm:py-2 rounded-full border border-gray-300 hover:bg-gray-100 text-gray-700 text-sm md:text-base"
        >
          Close
        </button>
        <button 
          className="px-4 py-1.5 sm:px-6 sm:py-2 rounded-full bg-blue-600 hover:bg-blue-700 text-white text-sm md:text-base"
          onClick={() => {
            setShowModal(false);
            setShowEnrollForm(true);
          }}
        >
          Enroll Now
        </button>
      </div>
    </div>
  </div>
)}
{showEnrollForm && (
  <div className="fixed inset-0 bg-black bg-opacity-50 z-[1050] flex justify-center items-start md:items-center p-4 overflow-y-auto">
    <div className="bg-white rounded-2xl shadow-xl w-full max-w-md md:max-w-lg lg:max-w-xl p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl md:text-2xl font-bold text-gray-800">
          Enroll in <span className="text-blue-600">{selectedWorkshop?.workshopName}</span>
        </h2>
        <button 
          onClick={handleCloseModal}
          className="text-gray-500 hover:text-gray-700 text-2xl bg-transparent border-none focus:outline-none"
          aria-label="Close modal"
        >
          &times;
        </button>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit} autoComplete="off" className="space-y-4">
        {['name', 'email', 'phone'].map((field) => (
          <div key={field} className="relative">
            <input
              type={field === 'email' ? 'email' : field === 'phone' ? 'tel' : 'text'}
              name={field}
              id={field}
              value={formData[field]}
              onChange={handleChange}
              required
              pattern={field === 'phone' ? "\\d{10}" : undefined}
                    maxLength={field === 'phone' ? 10 : undefined}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 peer"
              placeholder=" "
            />
            <label 
              htmlFor={field}
              className="absolute left-4 top-3 px-1 bg-white text-gray-500 transition-all duration-200 
                         peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-600
                         peer-placeholder-shown:top-3 peer-placeholder-shown:text-base
                         peer-[&:not(:placeholder-shown)]:-top-2 peer-[&:not(:placeholder-shown)]:text-xs"
            >
              {field.charAt(0).toUpperCase() + field.slice(1)}
            </label>
          </div>
        ))}

        <div className="relative">
          <textarea
            name="address"
            id="address"
            rows={3}
            value={formData.address}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 peer"
            placeholder=" "
          />
          <label 
            htmlFor="address"
            className="absolute left-4 top-3 px-1 bg-white text-gray-500 transition-all duration-200 
                       peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-600
                       peer-placeholder-shown:top-3 peer-placeholder-shown:text-base
                       peer-[&:not(:placeholder-shown)]:-top-2 peer-[&:not(:placeholder-shown)]:text-xs"
          >
            Address
          </label>
        </div>

        {/* Footer */}
        <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-4">
          <button
            type="button"
            onClick={handleCloseModal}
            className="px-6 py-2.5 rounded-lg border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium"
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="px-6 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium shadow-sm"
          >
            Submit Enrollment
          </button>
        </div>
      </form>
    </div>
  </div>
)}
    </>
  );
};

export default AllWorkshops;
